export default __webpack_public_path__ + "media/images/icons/question-circle-regular-a547bb3deb7e2b3c8d5d8356976b8126.svg";